// extracted by css-extract-rspack-plugin
export default {"ButtonRoot":"q30Wz","isSelected":"FvJ8q"};